// In Print.jsx
import React, { useContext, useEffect, useCallback } from "react";
import * as THREE from "three";
import { ControlContext } from "../../ControlContext.jsx";
import ChangeDepths from "../../Helpers/ChangeDepths.jsx";
import PaperFinish from "./PaperFinish.jsx";

export default function Print() {
  const {
    printWidth,
    printHeight,
    borderOffsetX,
    borderOffsetY,
    paperMaterial,
    frameType,
    printToneMapping,
    printExposure,
    borderWidth,
    borderHeight,
    paperType,
    faceMountFinish,
  } = useContext(ControlContext);

  const { printDepth } = ChangeDepths();

  // Update material properties
  // useEffect(() => {
  //   if (Array.isArray(paperMaterial) && paperMaterial[0]) {
  //     paperMaterial[0].toneMapped = printToneMapping !== THREE.NoToneMapping;
  //     if (paperMaterial[0].toneMapped) {
  //       paperMaterial[0].toneMapping = printToneMapping;
  //       paperMaterial[0].toneMappingExposure = printExposure;
  //     }
  //   }
  // }, [paperMaterial, printToneMapping, printExposure]);

  const castShadows = frameType === "Print" && borderWidth + borderHeight == 0;
  return (
    <>
      <mesh
        position={[borderOffsetX, borderOffsetY, printDepth]}
        castShadow={castShadows}
      >
        <planeGeometry args={[printWidth, printHeight]} />
        <meshBasicMaterial
          map={paperMaterial[0].map}
          shadowSide={THREE.DoubleSide}
          // toneMapped={printToneMapping !== THREE.NoToneMapping}
          // toneMapping={printToneMapping}
          // toneMappingExposure={printExposure}
        />
        {/* )} */}
      </mesh>
      <PaperFinish depth={printDepth}/>
    </>
  );
}
